import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ApplicationFacade, CardsNgrxFacade, CustomerCard } from '@ridango/components';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '@ridango/core';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import Env from '@ridango/core/env';
import { CardsPurchaseFacadeService } from '@ridango/widgets';

@Component({
    templateUrl: './cards-details-page.component.html'
})
export class CardsDetailsPageComponent extends BaseComponent implements OnInit, OnDestroy {
    assetsPath$ = this.applicationFacade.assetsPath$;
    selectedCard$: Observable<CustomerCard>;

    constructor(
        private applicationFacade: ApplicationFacade,
        private route: ActivatedRoute,
        private router: Router,
        private translate: TranslateService,
        private cardsFacade: CardsNgrxFacade,
        private cardsPurchaseFacadeService: CardsPurchaseFacadeService,
        @Inject('ENV') public env: Env
    ) {
        super();
    }

    ngOnInit(): void {
        this.cardsFacade.fetchCustomerCards();
        this.selectedCard$ = this.route.paramMap.pipe(
            takeUntil(this.componentDestroyed$),
            map((params) => parseInt(params.get('cardId'))),
            switchMap((cardId) => this.cardsFacade.getCardById(cardId))
        );
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    navigateCardsView() {
        this.router.navigate([this.translate.currentLang, 'account', 'cards']);
    }

    navigateToPurchaseFlow(selectedCard: CustomerCard) {
        this.cardsPurchaseFacadeService.navigateToPurchaseFlow(this.env, selectedCard);
    }

    navigateToEditView(card: CustomerCard) {
        this.router.navigate([this.translate.currentLang, 'account', 'cards', card?.relatedCardId, 'edit']);
    }

    unBlockCard(card: CustomerCard) {
        this.cardsFacade.unblockCard(card);
    }

    navigateToCardWallet(card: CustomerCard): void {
        const queryParams = card && card.cardNumber ? { cardNumber: card.cardNumber } : {};
        this.router.navigate([this.translate.currentLang, 'purchase', 'wallet'], { queryParams });
    }
}
